import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiGetUsers } from 'services/UserService'

export const initialState = {
    currentRouteKey: '',
    users: []
}

export const getUsers = createAsyncThunk('base/common', async (data) => {
    console.log('entra 2');
    
    const response = await apiGetUsers(data)
    return response.data
})

export const commonSlice = createSlice({
	name: 'base/common',
	initialState,
	reducers: {
        setCurrentRouteKey: (state, action) => {
            state.currentRouteKey = action.payload
        }
	},
    extraReducers: {
        [getUsers.fulfilled]: (state, action) => {
            state.users = action.payload
        },}
})

export const { setCurrentRouteKey } = commonSlice.actions

export default commonSlice.reducer